import Grid2 from "@mui/material/Grid2";

import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { M1TableCampaign } from "./components/M1TableCampaign";
import type {
	CampaignDelayResponse,
	CampaignResponse,
} from "@/pages/mill/schedule/models/CampaignReponse";
import {
	getM1CampaignDelays,
	getM1Campaigns,
} from "./repositories/M1CampaignRepository";

type useM1CampaignsProps = {
	onError: (error: Error) => void;
	campaignId?: number;
	start?: Date;
	end?: Date;
};

export const useM1Campaigns = ({
	campaignId,
	start,
	end,
	onError,
}: useM1CampaignsProps) => {
	return useQuery<CampaignResponse[], Error>({
		queryKey: ["m1Campaigns", campaignId, start?.getTime(), end?.getTime()],
		queryFn: ({ signal }) => getM1Campaigns({ campaignId, start, end }, signal),
		onError: onError,
		refetchInterval: 60_000,
	});
};

export const useM1CampaignDelays = ({
	start,
	end,
	onError,
}: useM1CampaignsProps) => {
	return useQuery<CampaignDelayResponse[], Error>({
		queryKey: ["m1CampaignDelays", start?.getTime(), end?.getTime()],
		queryFn: ({ signal }) => getM1CampaignDelays({ start, end }, signal),
		refetchInterval: 60_000,
		onError: onError,
	});
};

export const M1CampaignPage = () => {
	const { campaignId } = useParams();

	return (
		<>
			<HelmetDexteel title="M1 Schedule" />
			<Grid2 container justifyContent="center" alignItems="center">
				<Grid2 size={{ md: 12, xs: 12 }} style={{ margin: 0 }}>
					<M1TableCampaign campaignId={campaignId} />
				</Grid2>
			</Grid2>
		</>
	);
};
